import apiBaseUrl from '../../utils/config.js';

class SimpleAppointmentService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/simple-appointments`;
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  getAuthHeaders() {
    const token = this.getToken();

    return {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async request(endpoint, method = "GET", body = null) {
    const options = {
      method,
      headers: this.getAuthHeaders(),
    };

    if (body !== null && body !== undefined) {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(`${this.baseUrl}${endpoint}`, options);

    const text = await response.text();

    let data = null;

    if (text) {
      try {
        data = JSON.parse(text);
      } catch {
        data = text;
      }
    }

    if (!response.ok) {
      const message =
        data?.message ||
        data?.error ||
        data ||
        `Request failed with status ${response.status}`;

      throw new Error(message);
    }

    return data;
  }

  async addSimpleAppointment(appointment) {
    return this.request("/add", "POST", appointment);
  }

  async getAllSimpleAppointments() {
    return this.request("/all", "GET");
  }

  async getSimpleAppointmentById(id) {
    return this.request(`/${encodeURIComponent(id)}`, "GET");
  }

  async getSimpleAppointmentsByPatient(patientId) {
    return this.request(`/patient/${encodeURIComponent(patientId)}`, "GET");
  }

  async getSimpleAppointmentsByOffice(officeId) {
    return this.request(`/office/${encodeURIComponent(officeId)}`, "GET");
  }

  async getSimpleAppointmentsByDate(date) {
    return this.request(`/date/${encodeURIComponent(date)}`, "GET");
  }

  async getSimpleAppointmentsByOfficeAndDate(officeId, date) {
    return this.request(
      `/by-office-and-date?officeId=${encodeURIComponent(
        officeId
      )}&date=${encodeURIComponent(date)}`,
      "GET"
    );
  }

  /*
   * New clearer method name.
   *
   * Backend returns:
   * {
   *   officeId,
   *   date,
   *   openHour,
   *   closeHour,
   *   incraments,
   *   allSlots,
   *   bookedSlots,
   *   availableSlots,
   *   slotCounts,
   *   message
   * }
   */
  async getOfficeAvailability(officeId, date) {
    return this.request(
      `/available-times?officeId=${encodeURIComponent(
        officeId
      )}&date=${encodeURIComponent(date)}`,
      "GET"
    );
  }

  /*
   * Keep old method name so your existing AppointmentScheduler
   * or any other page does not break.
   */
  async getAvailableTimes(officeId, date) {
    return this.getOfficeAvailability(officeId, date);
  }

  async updateSimpleAppointment(id, appointment) {
    return this.request(`/update/${encodeURIComponent(id)}`, "PUT", appointment);
  }

  async deleteSimpleAppointment(id) {
    return this.request(`/delete/${encodeURIComponent(id)}`, "DELETE");
  }

  async updateConformationOnly(id, conformation) {
    return this.request(`/update-conformation/${encodeURIComponent(id)}`, "PATCH", {
      conformation,
    });
  }
}

export default SimpleAppointmentService;